// extracted by mini-css-extract-plugin
export default {"logOutBtn":"LogOutBtn_logOutBtn__ottsn","user":"LogOutBtn_user__TkuLb"};